import { prefetchApps } from 'qiankun';
import { getMicroAppList } from '@/micro/index';
// eslint-disable-next-line import/no-cycle
import { isJSONString, parseJSONIfArray } from '@/utils/utils';
import { hasYjbParameter } from '@/utils/intConfiguration';
import { domainNamDsl } from './dsl';
import { genWaterMark } from '../markImg';

class Baseunified {
  constructor() {
    if (typeof Baseunified.instance === 'object') {
      return Baseunified.instance;
    }
    Baseunified.instance = this;
    this.init();
  }

  /**
   * @function 初始化
   * @return void
   */
  // eslint-disable-next-line class-methods-use-this
  init() {
    this.dslModel = this.getDslModel();
  }

  /**
   * @function 本地调试和线上获取对应的描述 (本地调试选择了系统后才会生效)
   * @return {Arrary} 当前的描述
   */
  // eslint-disable-next-line class-methods-use-this
  getDslModel() {
    // eslint-disable-next-line no-unused-vars
    let dslModel = [];
    function filterAppId() {
      let hostname = '';
      const appId = localStorage.getItem('appId') || '';
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < domainNamDsl.length; i++) {
        if (appId === domainNamDsl[i].appId) {
          hostname = domainNamDsl[i].name;
          break;
        }
      }
      return hostname;
    }
    /**
     * 自营上线 临时处理
     */
    // eslint-disable-next-line camelcase
    //    const gyl_dsl = {
    //      name: 'tboss',
    //      preload: false,
    //      preloadPort: [],
    //      watermark: false,
    //      businessHeader:
    //      {
    //        Msg: 'right',
    //      },
    //      redirect: false,
    //      defaultHomePage: '',
    //      appId: '20001',
    //      imagesObj: {
    //        home: '',
    //      },
    //      loginDefine: [
    //        {
    //          name: '账号登录',
    //          component: 'UserNameLogin',
    //        },
    //        {
    //          name: '手机号登录',
    //          component: 'VerificationLogin',
    //        },
    //      ],
    //      elements: ['ForgetPassword', 'ChangingPassword'],
    //    };
    //    if (window.location.hostname.toString().includes('tboss')) {
    //      // eslint-disable-next-line camelcase
    //      return gyl_dsl;
    //    }
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < domainNamDsl.length; i++) {
      if ((process.env.NODE_ENV === 'development' ? filterAppId() : window.location.hostname.toString()).includes(domainNamDsl[i].name)) {
        dslModel = domainNamDsl[i];
        break;
      }
    }
    return dslModel;
  }

  /**
   * @function 根据DSL抛出当前项目需要显示的模块
   * @return {Object} 俩个数组 分别是显示在俩侧的模块
   */
  // eslint-disable-next-line class-methods-use-this
  showHeaderModule() {
    this.init();
    // eslint-disable-next-line prefer-const
    let obj = {
      left: [],
      right: [],
    };
    Object.getOwnPropertyNames(this.dslModel.businessHeader).forEach((key) => {
      if (this.dslModel.businessHeader[key] === 'left') {
        obj.left.push(key);
      }
      if (this.dslModel.businessHeader[key] === 'right') {
        obj.right.push(key);
      }
    });
    return obj;
  }

  /**
   * @function 根据DSL判断当前系统watermark=true开启水印
   * @return void
   */
  // eslint-disable-next-line class-methods-use-this
  getWateMarkHost() {
    this.init();
    function addWateMark() {
      const userInfo = localStorage.getItem('user_info');
      const info = JSON.parse(userInfo);
      const option = {
        // eslint-disable-next-line quotes
        content: `${info.aliasName}  ${info.jobNumber}`,
        className: 'watermarked',
      };
      genWaterMark(option);
    }
    if (this.dslModel.watermark) {
      addWateMark();
    }
  }

  /**
   * @function 根据域名进行子应用的预加载
   * @return void
   */
  starMicroApp() {
    this.init();
    const microAppList = getMicroAppList();
    function start(appls) {
      const pref = [];
      // 微应用
      microAppList.forEach((em) => {
        if (appls.includes(em.port)) {
          pref.push({
            name: em.name,
            entry: em.entry,
          });
        }
      });
      prefetchApps(pref);
    }
    if (this.dslModel.preloadPort.length > 0 && this.dslModel.preload) {
      start(this.dslModel.preloadPort);
    }
  }

  /**
   * @function 钉钉重定向
   */
  /**
   * @function 返回登录集合
   * @return {Arrary}
   */

  getLoginDefine() {
    this.init();
    // 默认不存在账号登录信息
    localStorage.setItem('whetherAccountExists', '0');
    if (isJSONString('uiInfo') && process.env.NODE_ENV !== 'development') {
      const uiInfo = JSON.parse(localStorage.getItem('uiInfo'));
      const k = parseJSONIfArray(uiInfo.appLoginType);
      // eslint-disable-next-line prefer-const
      let keys = [];
      // if (k.includes('4')) {
      //   keys.push({
      //     name: '域账号登录',
      //     component: 'AccountLogin',
      //   });
      // }
      if (k.includes('1')) {
        keys.push({
          name: '手机号登录',
          component: 'VerificationLogin',
        });
      }
      if (k.includes('2')) {
        keys.push({
          name: '账号登录',
          component: 'UserNameLogin',
        });
        // 存在账号，就存在此信息，是1
        localStorage.setItem('whetherAccountExists', '1');
      }
      return keys;
    } if (!isJSONString('uiInfo') && hasYjbParameter()) {
      return [
        {
          name: '手机号登录',
          component: 'VerificationLogin',
        },
      ];
    }
    return [
      // {
      //   name: '域账号登录',
      //   component: 'AccountLogin',
      // },
      {
        name: '账号登录',
        component: 'UserNameLogin',
      },
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ];

    return this.dslModel.loginDefine;
  }
}
export default Baseunified;
